import React, { useState, useEffect } from "react";
import { HashLink as Link } from "react-router-hash-link";
import logo from "../../assets/img/logo.svg";
import "../../assets/css/general.css";
import "../../assets/css/responsive.css"; // Import your CSS file for the new nav

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const toggleMenu = () => {
    if (isOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsOpen(false);
        setIsClosing(false);
      }, 300);
    } else {
      setIsOpen(true);
    }
  };

  useEffect(() => {
    document.body.style.overflow = isOpen && !isClosing ? "hidden" : "auto";
  }, [isOpen, isClosing]);

  return (
    <section className="nav2-section">
      <button
        className={`nav2-burger ${isOpen ? "open" : ""}`}
        onClick={toggleMenu}
      >
        <span />
        <span />
        <span />
      </button>

      <div className="nav2-right">
        <div className="nav2-logo">
          <Link to="/#">
            <img src={logo} alt="logo" style={{ width: "50px" }} />
          </Link>
        </div>
        <Link className="nav2-links" to="/offer/#hero-offer">
          Offres d'emploi
        </Link>
        <Link className="nav2-links" to="/agency/#agency-hero">
          Nos agences
        </Link>
      </div>

      <div className="nav2-left">
        <Link className="btn empty nav2-links" to="/login">
          Connexion
        </Link>
        <Link className="btn fill blue nav2-links" to="/candidature">
          Candidature
        </Link>
      </div>

      <div
        className={`nav2-mobile-menu ${
          isOpen ? "open" : isClosing ? "closing" : ""
        }`}
      >
        <Link className="nav2-links" to="/offer" onClick={toggleMenu}>
          Offres d'emploi
        </Link>
        <Link className="nav2-links" to="/agency" onClick={toggleMenu}>
          Nos agences
        </Link>
        <Link className="btn empty nav2-links" to="/login" onClick={toggleMenu}>
          Connexion
        </Link>
        <Link
          className="btn fill blue nav2-links"
          to="/candidature"
          onClick={toggleMenu}
        >
          Candidature
        </Link>
      </div>
    </section>
  );
};

export default Nav;
